import { api } from "./api";
import { ENDPOINTS } from "./endpoints";
import { operations } from "../types/openapi";

type getAllBankAccountByCompanyId = operations["getAllBankAccountByCompanyId"];
type getBankAccountByCompanyId = operations["getBankAccountByCompanyId"];
type createBankAccount = operations["createBankAccount"];
type deleteBankAccount = operations["defaultBankAccount"];
type archiveBankAccount = operations["archiveBankAccount"];
type getAllBank = operations["getAllBank"];

/**
 * Получение списка банковских реквизитов компании (доступно для CUSTOMER, OPERATOR, LIQUIDITY_PROVIDER)
 */
export const fetchGetBankAccounts = ({
  id,
}: getAllBankAccountByCompanyId["parameters"]["path"]): Promise<
  getAllBankAccountByCompanyId["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.bankAccount(id));
};

/**
 * Получение карточки банковских реквизитов (доступно для CUSTOMER, OPERATOR, LIQUIDITY_PROVIDER)
 */
export const fetchGetBankAccountDetails = ({
  companyId,
  id,
}: getBankAccountByCompanyId["parameters"]["path"]): Promise<
  getBankAccountByCompanyId["responses"]["200"]["content"]["*/*"]
> => {
  return api.get(ENDPOINTS.getBankAccountDetails(companyId, id));
};

/**
 * Создание банковского счета
 */
export const newBankDetails = (
  { id }: createBankAccount["parameters"]["path"],
  formData: createBankAccount["requestBody"]["content"]["application/json"]
): Promise<string> => {
  return api.post(ENDPOINTS.bankAccount(id), formData);
};

/**
 * Установка банковского счета по умолчанию для компании (доступно для CUSTOMER, OPERATOR, LIQUIDITY_PROVIDER)
 */
export const setDefaultBankDetails = ({
  id,
  accountId,
}: deleteBankAccount["parameters"]["path"]): Promise<deleteBankAccount["responses"]["200"]["content"]> => {
  return api.put(ENDPOINTS.setDefaultBankDetails(id, accountId));
};

/**
 *  Архивация банковского счета компании (доступно для CUSTOMER, OPERATOR, LIQUIDITY_PROVIDER)
 */
export const deleteBankDetails = ({
  id,
  accountId,
}: archiveBankAccount["parameters"]["path"]): Promise<archiveBankAccount["responses"]["200"]["content"]> => {
  return api.post(ENDPOINTS.deleteBankDetails(id, accountId));
};

/**
 * Грид банков (доступно для CUSTOMER, OPERATOR, LIQUIDITY_PROVIDER)
 */
export const getBankList = (
  query: getAllBank["parameters"]["query"]
): Promise<getAllBank["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.bankList(), query);
};
